import React from 'react';
import * as styles from './heading.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Heading = _ref => {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    className = _ref.className;
  return ___EmotionJSX("div", {
    css: styles.heading,
    className: className
  }, ___EmotionJSX("h2", {
    css: styles.title
  }, title), subtitle && ___EmotionJSX("div", {
    css: styles.subtitle
  }, subtitle));
};